import { render, staticRenderFns } from "./AssembleiaEdit.vue?vue&type=template&id=64ed699e&"
import script from "./AssembleiaEdit.vue?vue&type=script&lang=js&"
export * from "./AssembleiaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports